import { Loader } from "@nimble/react-requests/components/shared/loader";

export default function AuthPageLoader() {
  return (
    <Loader
      className="mx-auto mt-20 text-ink-faint"
      data-testid="auth-page-loader"
    />
  );
}
